import { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, message } from "antd";
import {
  getAllRoles,
  addRole,
  updateRole,
  deleteRole
} from "../services/roleService";
import { toast } from 'react-toastify';

const Roles = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [deletingRole, setDeletingRole] = useState(null);
  const [form] = Form.useForm();

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const roleList = await getAllRoles();
      setRoles(roleList);
    } catch {
      message.error("Roller alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddOrUpdate = async (values) => {
    try {
      let response;
      if (editingRole) {
        response = await updateRole({ ...editingRole, ...values });
      } else {
        response = await addRole(values);
      }

      if (response?.Status) {
        toast.success(response?.Message || response?.MessageCode || "İşlem başarılı.");
      } else {
        toast.error(response?.Message || "İşlem başarısız.");
      }

      fetchRoles();
      setIsModalOpen(false);
      form.resetFields();
      setEditingRole(null);
    } catch (error) {
      const msg = error?.response?.data?.Message || "İşlem sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await deleteRole(id);
      if (response?.Status) {
        toast.success(response?.Message || response?.MessageCode || "Silme işlemi başarılı.");
        fetchRoles();
      } else {
        toast.error(response?.Message || "Silme işlemi başarısız.");
      }
    } catch (error) {
      const msg = error?.response?.data?.Message || "Silme sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div>
      <h2>Roller</h2>
      <Button type="primary" onClick={() => setIsModalOpen(true)}>
        Yeni Rol Ekle
      </Button>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={roles}
        columns={[
          { title: "Ad", dataIndex: "name" },
          { title: "Açıklama", dataIndex: "description" },
          {
            title: "İşlem",
            render: (text, record) => (
              <>
                <Button
                  onClick={() => {
                    setEditingRole(record);
                    form.setFieldsValue(record);
                    setIsModalOpen(true);
                  }}
                  style={{ marginRight: 8 }}
                >
                  Güncelle
                </Button>
                <Button
                  danger
                  onClick={() => {
                    setDeletingRole(record);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  Sil
                </Button>
              </>
            ),
          },
        ]}
      />

      {/* Ekle / Güncelle Modal */}
      <Modal
        title={editingRole ? "Rol Güncelle" : "Rol Ekle"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingRole(null);
          form.resetFields();
        }}
        onOk={() => form.submit()}
      >
        <Form form={form} onFinish={handleAddOrUpdate} layout="vertical">
          <Form.Item name="name" label="Rol Adı" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Açıklama">
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>

      {/* Silme Onay Modalı */}
      <Modal
        title="Silme işlemini onaylıyor musunuz?"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        onOk={() => {
          if (deletingRole) {
            handleDelete(deletingRole.id);
            setIsDeleteModalOpen(false);
          }
        }}
        okText="Evet, Sil"
        okType="danger"
        cancelText="Vazgeç"
      >
        <p>
          "{deletingRole?.name}" adlı rol silinecek. Bu işlemi onaylıyor musunuz?
        </p>
      </Modal>
    </div>
  );
};

export default Roles;
